// extracted by mini-css-extract-plugin
export default {"link":"styles_link__ukrTX","title":"styles_title__GtS0E","subtitle":"styles_subtitle__7NyGZ"};